export default "* Leg\n* Regler";